/**
 * IBaseModel is any model object that is stored in any form of persistent storage
 * and therefore should have `createdAt` and `updatedAt` fields for auditing
 */
export class BaseModel {
    _id?: string;
    createdAt?: Date;
    updatedAt?: Date;
}
